import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class HappiService {
  private showHappiIcon$ = new BehaviorSubject<boolean>(false);
  
  readonly isHappiAvailable$ = this.showHappiIcon$.asObservable();

  setHappiAvailability(isAvailable: boolean): void {
    this.showHappiIcon$.next(isAvailable);
  }
}